import axios from 'axios'
import {
    FETCH_BOLSA,
    APIpath,
    addToast,
    setRedirect
} from '../actions'

const setBolsa = (bolsa) => ({
    type: FETCH_BOLSA,
    bolsa
})

export const fetchActiveBolsa = () => (dispatch) => {
    dispatch(setRedirect(false))
    axios.get(`${APIpath}/bolsa/active-post`)
        .then(function (response) {
            dispatch(setBolsa(response.data))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const createPostulacion = (values) => (dispatch) => {
    axios.post(`${APIpath}/bolsa-solicitud/store`, values)
        .then(function (response) {
            dispatch(setRedirect(true))
            dispatch(addToast('success', 'Su solicitud ha sido enviada'))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}